import { translate } from '@vimeo/i18n-runtime';

type PictureSize = {
  width: number;
  link: string;
};

// Get URLs of video author's normal sized and 2X profile pictures
export const getAvatarImages = (pix?: PictureSize[]): string[] => {
  const defaultSrc = 'https://i.vimeocdn.com/custom_asset/92992640f627fdad710e4c3cb728b1b2';
  const size1x = 72;
  const size2x = 144;

  const src = pix?.find((p) => p.width === size1x)?.link || pix?.[1]?.link || defaultSrc;
  const srcSet = pix?.find((p) => p.width === size2x)?.link || pix?.[2]?.link || defaultSrc;

  return [src, `${srcSet} 2x`];
};

export const convertTimeCodeToSeconds = (timeCode: string | null | undefined) => {
  if (!timeCode) {
    return 0;
  }
  const timeParts = timeCode.split(':');
  const minutes = parseInt(timeParts[0], 10);
  const seconds = parseInt(timeParts[1], 10);

  const totalSeconds = minutes * 60 + seconds;

  return totalSeconds;
};

/**
 * Get resource id from single level resource uri (i.e - /video/1234 --> 1234, comments/2442/reply/987 --> 987)
 */
export const idFromUri = (uri: string | undefined | null): number => {
  return uri ? parseInt(uri.substring(uri.lastIndexOf('/') + 1), 10) : 0;
};

export const EMAIL_REGEX = /^\w+([\+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;

/**
 * Converts iso datetime string to 'Jan 6, 2025 at 10:56 pm' format.
 * @param isoDateTimeString - e.g. '2019-11-15T05:05:16'
 */
export function convertDateTime(isoDateTimeString: string) {
  const date = new Date(isoDateTimeString);
  const locale = navigator.language || 'en-US';
  const dateFormatter = new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  const timeFormatter = new Intl.DateTimeFormat(locale, {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });
  const formattedDate = dateFormatter.format(date);
  const formattedTime = timeFormatter.format(date);

  return translate({
    singular: '{DATE} at {TIME}',
    replacements: {
      DATE: formattedDate,
      TIME: formattedTime,
    },
  });
}
